import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

export interface ExportDTBResponse {
  jobId?: string;
  presignedUrl?: string;
  base64?: string;
  fileType?: 'PDF' | 'DOCX';
}

export const getExportDTB = async(orgId: string, dtbId: string) => {
  const url = `${baseApiUrl()}/lexiverse/export/v1/organizations/${orgId}/dtbs/${dtbId}/export`;
  const queryParams = new URLSearchParams({
    exportType: 'PDF',
  });

  const finalUrl = `${url}?${queryParams.toString()}`;

  const data = await fetcher({
    method: 'get',
    url: finalUrl,
  });

  return data;
};

export default function useExportDTB() {
    const exportDTB = async (
    orgId: string,
    dtbId: string,
    callback?: (data: ExportDTBResponse) => void,
    onError?: (errors: ServerErrorResponse) => void
    ) => {
      try {
        // getExportDTB returns a react-query object, not plain data
        const data = await getExportDTB(orgId, dtbId);
        if (callback) await callback(data);
        return data;
      } catch (err) {
        if (onError) {
          // Handle error with callback and don't throw to prevent React error boundary
          handleError(err as Error, { onError });
          return;
        }
        // Only throw if no error handler is provided
        throw err;
      }
    };
  
    return {
      exportDTB,
    };
  }
